module.exports = __webpack_public_path__ + "static/img/division_6.0f677f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/fortnite/division_6.svg
// module id = 129d
// module chunks = 35